export class OrderNavigation {
    public static TAB = 'TAB';
    public static OPEN_TABS = 'OPEN_TABS';
    public static NEW_ORDER = 'NEW_ORDER';
}
